import { render, staticRenderFns } from "./order_perfect.vue?vue&type=template&id=623c1ade&scoped=true"
import script from "./order_perfect.vue?vue&type=script&lang=js"
export * from "./order_perfect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c1ade",
  null
  
)

export default component.exports